/**
 * Checks if a URL is a stream URL from the generation API
 * @param url - The URL to check
 * @returns True if the URL is a stream URL
 */
export function isStreamUrl(url: string): boolean {
  return url.includes('api.musicgpt.com') && url.includes('/stream');
}
